export default __webpack_public_path__ + "static/media/grid-view-icon.69fd65ed.svg";